<div *ngIf="selectionType && nodes" >
  <div *ngIf="selectionType == FilterSelectionTypes.Multiple" class="card flex justify-center">
    <p-tree
    class="w-full md:w-80"
    styleClass="w-full md:w-[30rem]"
    scrollHeight="380px"
    [value]="nodes"
    [(selection)]="selectedNodes"
    (selectionChange)="onSelectionChange()"
    display="chip"
    [metaKeySelection]="false"
    selectionMode="checkbox"
    placeholder="Select Item"
    [virtualScroll]="true"
    [virtualScrollItemSize]="46"
    />
    <!-- [(ngModel)]="selectedNodes" -->
    <!--  -->

  </div>
  <div *ngIf="selectionType == FilterSelectionTypes.Single" class="card flex justify-center">
    <p-listbox
    [(ngModel)]="selectedNodes"
    (ngModelChange)="onSelectionChange()"
    [options]="nodes"
    optionLabel="name"
    [checkmark]="true"
    [highlightOnSelect]="false"
    class="w-full md:w-56" />
  </div>
</div>
